import React from 'react'
import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Center
} from '@chakra-ui/react'
export default function ErrorComponent(props) {
    return (
        <Center m="auto" width="60%" mb="3">
            <Alert
                status="error"
                variant="subtle"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                height="200px"
            >
                <AlertIcon boxSize="40px" mr={0} />
                <AlertTitle mt={4} mb={1} fontSize="lg">
                    An Error Occured!
                </AlertTitle>
                <AlertDescription maxWidth="sm">
                    {props.message}
                </AlertDescription>
            </Alert>
        </Center>

    )
}
